import React from 'react';
import { Box, Button, Typography, Paper, Container, CircularProgress } from '@mui/material';
import { useAuth0 } from '../context/Auth0Context';
import LockIcon from '@mui/icons-material/Lock';

const LoginPage: React.FC = () => {
    const { loginWithRedirect, isLoading, error } = useAuth0();

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    textAlign: 'center',
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <LockIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />

                    <Typography variant="h4" component="h1" gutterBottom>
                        Secure Access Required
                    </Typography>

                    <Typography variant="body1" color="text.secondary" paragraph>
                        This application contains sensitive transaction building functionality.
                        Please log in to continue.
                    </Typography>

                    {isLoading ? (
                        <CircularProgress sx={{ mt: 3, mb: 2 }} />
                    ) : (
                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => loginWithRedirect()}
                            sx={{ mt: 3, mb: 2, py: 1.5, px: 4 }}
                        >
                            Log In
                        </Button>
                    )}

                    {error && (
                        <Typography color="error" sx={{ mt: 2 }}>
                            {error.message}
                        </Typography>
                    )}

                    <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
                        By logging in, you agree to our terms of service and privacy policy.
                    </Typography>
                </Paper>
            </Box>
        </Container>
    );
};

export default LoginPage;
